<div>
  <div class="modal-body">
    <p class="lead">
      You are about to approve this application for progression to the next processing stage.
      Please confirm whether an additional review by the Company Registrar is required.
    </p>

    <label class="toggle">
      <nz-switch [(ngModel)]="withRequestReview"></nz-switch>
      <span>Request Company Registrar Review</span>
    </label>
    <textarea style="margin-top: 10px;" maxlength="4000" *ngIf="withRequestReview" rows="6" nz-input class="w-100" [(ngModel)]="reason" placeholder="Please provide a reason for requiring additional approval."
    ></textarea>
  </div>
</div>

<div class="modal-footer">
  <button nz-button class="btn-cancel" nzType="text" (click)="cancel()">Cancel</button>
  <button nz-button class="btn-confirm" nzType="primary" (click)="confirm()" [disabled]="isConfirmDisabled()">Confirm</button>
</div>
